import {
  updateTimepointContainerSubmissionStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdContainerSubmissionsPatch,
  UpdateTimepointContainerSubmissionStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdContainerSubmissionsPatchResponse,
  UpdateTimepointContainerSubmissionStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdContainerSubmissionsPatchData,
  HTTPValidationError,
} from '@common/config/api/client'
import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { queryClient } from '@common/config/api/queryClient.ts'
import { queryKeyFactory } from '@features/study_details/Subjects/queryKeyFactory'

export const useUpdateContainerSubmission = () => {
  return useMutation<
    UpdateTimepointContainerSubmissionStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdContainerSubmissionsPatchResponse,
    AxiosError<HTTPValidationError>,
    UpdateTimepointContainerSubmissionStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdContainerSubmissionsPatchData
  >({
    mutationFn: async (query) => {
      const response =
        await updateTimepointContainerSubmissionStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdContainerSubmissionsPatch(
          {
            body: query.body,
            path: query.path,
            throwOnError: true,
          },
        )
      return response.data
    },
    onSuccess: (_, query) => {
      void queryClient.invalidateQueries({ queryKey: ['TimePointsDetails', query.path.timepoint_submission_id] })
      void queryClient.invalidateQueries({ queryKey: ['SubjectsList'] })
      void queryClient.invalidateQueries({
        queryKey: queryKeyFactory.subjectTimepoints({
          study_id: query.path.study_id,
          subject_id: query.path.subject_id,
        }),
      })
    },
  })
}
